import { create } from 'zustand';

export interface ToastItem {
  id: string;
  type: 'message' | 'like' | 'comment' | 'wall' | 'system';
  title: string;
  content?: string;
  fromUserId?: number;
  fromUsername?: string;
  createdAt: string;
}

interface ToastStore {
  toasts: ToastItem[];
  addToast: (toast: ToastItem) => void;
  removeToast: (id: string) => void;
  enabled: boolean;
  setEnabled: (v: boolean) => void;
}

export const useToastStore = create<ToastStore>((set) => ({
  toasts: [],
  enabled: localStorage.getItem('notifications_enabled') !== 'false',
  addToast: (toast) => set((state) => ({
    toasts: [...state.toasts, toast].slice(-5),
  })),
  removeToast: (id) => set((state) => ({
    toasts: state.toasts.filter((t) => t.id !== id),
  })),
  setEnabled: (v) => {
    localStorage.setItem('notifications_enabled', String(v));
    set({ enabled: v });
  },
}));
